export const cookieOption: { maxAge: number; path: string } = {
  path: '/',
  maxAge: 86400 * 2,
}
